/* eslint no-param-reassign: 0 */

export const confirmedPasses = $ =>
  $.cart.skipasses.filter(pass => pass.confirmed);

export const guidedPasses = $ =>
  $.cart.skipasses.filter(pass => pass.guideCompleted);

export default 'bar';



// WEBPACK FOOTER //
// ./src/store-methods/getters/pass.js